// Vergleichsgrafik der Einzelseiten (Block „Einordnung“ in sections/marmota-objekt.liquid):
// Beim Darüberfahren erscheinen Platz, Name und Wert des Balkens; ein Klick öffnet die Seite dieses Gipfels bzw. Passes.
// Maus: Hinweis folgt dem Zeiger. Finger: erstes Tippen zeigt, zweites Tippen auf denselben Balken öffnet; seitlich wischen geht durch die Reihe.
// Tastatur: Pfeiltasten wählen, Eingabetaste öffnet. Ohne Skript bleibt die Grafik, wie sie ist.
(() => {
  function starten(reihe) {
    if (reihe.dataset.bereit) return;
    reihe.dataset.bereit = "1";
    const balken = [...reihe.children];
    const tipp = reihe.parentElement.querySelector(".mm-reihe__tipp");
    const hinweis = reihe.closest(".mm-einordnung")?.querySelector(".mm-reihe__hinweis");
    if (!balken.length || !tipp) return;
    if (hinweis) {
      if (reihe.dataset.hinweisTouch && matchMedia("(hover: none)").matches) hinweis.textContent = reihe.dataset.hinweisTouch;
      hinweis.hidden = false;
    }
    const ich = Math.max(0, balken.findIndex((b) => b.classList.contains("mm-reihe__ich")));
    let aktiv = -1;

    function zeigen(i) {
      if (i === aktiv) return;
      balken[aktiv]?.classList.remove("mm-reihe__aktiv");
      aktiv = i;
      if (i < 0) { tipp.classList.remove("mm-reihe__tipp--an"); reihe.style.cursor = ""; return; }
      const b = balken[i];
      b.classList.add("mm-reihe__aktiv");
      tipp.textContent = b.dataset.text + (b.dataset.url ? " →" : "");
      tipp.classList.add("mm-reihe__tipp--an");
      reihe.style.cursor = b.dataset.url ? "pointer" : "default";
      // über dem Balken, ohne über den Rand der Grafik zu ragen
      const r = reihe.parentElement.getBoundingClientRect(), rb = b.getBoundingClientRect();
      const w = tipp.offsetWidth, h = tipp.offsetHeight;
      tipp.style.left = Math.round(Math.min(Math.max(rb.left + rb.width / 2 - r.left - w / 2, 0), Math.max(r.width - w, 0))) + "px";
      tipp.style.top = Math.round(rb.top - r.top - h - 6) + "px";
    }
    // nächster Balken zur Zeigerposition (die Lücken zwischen den Balken zählen zum Nachbarn)
    function bei(x) {
      let best = -1, abstand = Infinity;
      balken.forEach((b, i) => {
        const r = b.getBoundingClientRect();
        const d = x < r.left ? r.left - x : x > r.right ? x - r.right : 0;
        if (d < abstand) { abstand = d; best = i; }
      });
      return best;
    }
    const oeffnen = (i) => { const url = balken[i]?.dataset.url; if (url) location.href = url; };

    let art = "mouse", vorher = -1;
    reihe.addEventListener("pointermove", (e) => zeigen(bei(e.clientX)));
    reihe.addEventListener("pointerleave", (e) => { if (e.pointerType === "mouse" && document.activeElement !== reihe) zeigen(-1); });
    reihe.addEventListener("pointerdown", (e) => { art = e.pointerType; vorher = aktiv; zeigen(bei(e.clientX)); });
    reihe.addEventListener("click", (e) => {
      const i = bei(e.clientX);
      if (art !== "mouse" && i !== vorher) return;   // Finger: erst zeigen, beim zweiten Tippen öffnen
      oeffnen(i);
    });
    reihe.addEventListener("focus", () => zeigen(aktiv >= 0 ? aktiv : ich));
    reihe.addEventListener("blur", () => zeigen(-1));
    reihe.addEventListener("keydown", (e) => {
      const i = aktiv < 0 ? ich : aktiv, n = balken.length;
      const ziel = { ArrowRight: i + 1, ArrowDown: i + 1, ArrowLeft: i - 1, ArrowUp: i - 1, Home: 0, End: n - 1 }[e.key];
      if (ziel !== undefined) { e.preventDefault(); zeigen(Math.min(Math.max(ziel, 0), n - 1)); }
      else if (e.key === "Enter") oeffnen(i);
      else if (e.key === "Escape") reihe.blur();
    });
  }
  const alle = (w = document) => w.querySelectorAll("[data-marmota-reihe]").forEach(starten);
  alle();
  // Theme-Editor: Abschnitte werden neu gezeichnet, ohne dass die Seite neu lädt
  document.addEventListener("shopify:section:load", (e) => e.target && alle(e.target));
})();
